import { TYPES } from './typeDetector.js';

export const GROUPS = Object.freeze({
  PERSON: 'Persona',
  CHANNEL: 'Canals de comunicació',
  GEO: 'Geogràfic',
  PROFESSIONAL: 'Perfil professional',
  GDPR: 'Permisos / GDPR',
  IDENTIFIER: 'Identificadors',
  DATES: 'Dates',
  OTHER: 'Altres',
});

const RULES = [
  { group: GROUPS.PERSON, patterns: ['nom', 'name', 'cognom', 'apellido', 'lastname', 'firstname', 'gender', 'genere', 'género', 'sexo', 'birth', 'naixement', 'nacimiento', 'fecha_nac', 'date_of_birth', 'dob', 'persona'] },
  { group: GROUPS.CHANNEL, patterns: ['email', 'correo', 'mail', 'phone', 'telef', 'mobil', 'movil', 'mobile', 'whatsapp', 'fax'] },
  { group: GROUPS.GEO, patterns: ['street', 'carrer', 'calle', 'address', 'adress', 'adreca', 'direccion', 'direcció', 'postal', 'cp', 'zip', 'city', 'ciutat', 'ciudad', 'localidad', 'state', 'provincia', 'estado', 'region', 'regio', 'country', 'pais', 'país'] },
  { group: GROUPS.PROFESSIONAL, patterns: ['profess', 'profesi', 'category', 'categoria', 'specialty', 'especial', 'company', 'empresa', 'role', 'rol', 'cargo', 'job'] },
  { group: GROUPS.GDPR, patterns: ['privacy', 'gdpr', 'rgpd', 'subscrip', 'optin', 'opt-in', 'opt_out', 'optout', 'consent', 'consentim', 'subuns', 'permis', 'newsletter'] },
  { group: GROUPS.IDENTIFIER, patterns: ['id', 'codi', 'codigo', 'reference', 'referencia', 'sourceid', 'externalid', 'uuid', 'crmid'] },
];

function normalize(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '');
}

function normalizePattern(p) {
  return String(p).toLowerCase().replace(/[^a-z0-9]+/g, '');
}

const NORMALIZED_RULES = RULES.map((r) => ({
  group: r.group,
  patterns: r.patterns.map(normalizePattern),
}));

export function classifyField(name, detectedType) {
  const norm = normalize(name);
  for (const rule of NORMALIZED_RULES) {
    if (rule.patterns.some((p) => norm.includes(p))) {
      return rule.group;
    }
  }
  if (detectedType === TYPES.EMAIL) return GROUPS.CHANNEL;
  if (detectedType === TYPES.DATE) return GROUPS.DATES;
  if (/^id/.test(norm) || /id$/.test(norm)) return GROUPS.IDENTIFIER;
  return GROUPS.OTHER;
}

export function groupColumns(columns) {
  const groups = new Map();
  for (const col of columns) {
    const group = classifyField(col.name, col.detectedType);
    if (!groups.has(group)) groups.set(group, []);
    groups.get(group).push(col.name);
  }
  return [...groups.entries()].map(([group, fields]) => ({ group, fields }));
}
